export const KNOWLEDGE_CATEGORY_LIST_ATTEMPT = "KNOWLEDGE_CATEGORY_LIST_ATTEMPT";
export const KNOWLEDGE_CATEGORY_LIST_SUCCESS = "KNOWLEDGE_CATEGORY_LIST_SUCCESS";
export const KNOWLEDGE_CATEGORY_LIST_FAILED = "KNOWLEDGE_CATEGORY_LIST_FAILED";
////////////
export const KNOWLEDGE_CATEGORY_MORELIST_ATTEMPT = "KNOWLEDGE_CATEGORY_MORELIST_ATTEMPT";
export const KNOWLEDGE_CATEGORY_MORELIST_SUCCESS = "KNOWLEDGE_CATEGORY_MORELIST_SUCCESS";
export const KNOWLEDGE_CATEGORY_MORELIST_FAILED = "KNOWLEDGE_CATEGORY_MORELIST_FAILED";

